import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';

import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { IconType, SvgIcon } from '../General/SvgIcon';

export interface Props {
  contacts: any;
}

function FooterContactRow({ contacts }: Props) {
  const renderIcon = type => {
    switch (type) {
      case 'email':
        return (
          <SvgIcon
            icon={IconType.email}
            width={24}
            height={24}
            marginRight={12}
            cursor="pointer"
          />
        );
      case 'phone':
        return (
          <SvgIcon
            icon={IconType.phone}
            width={24}
            height={24}
            marginRight={12}
            cursor="pointer"
          />
        );
      case 'facebook':
        return (
          <SvgIcon
            icon={IconType.facebook}
            width={24}
            height={24}
            marginRight={12}
            cursor="pointer"
          />
        );
      default:
        return null;
    }
  };

  const linksComponent =
    contacts &&
    contacts.map((c: any, index: number) => (
      <>
        <ContactItem key={index}>
          {renderIcon(c.type)}
          <ContactLink href={`${c.url}`} target="_blank">
            {c.value}
          </ContactLink>
          {c.smallText && c.smallText !== '' && (
            <SmallText>- {c.smallText}</SmallText>
          )}
        </ContactItem>
      </>
    ));
  return (
    <Wrapper>
      <ContentWrapper>
        {linksComponent && linksComponent.length > 0 ? linksComponent : null}
      </ContentWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  justify-content: center;
  flex-wrap: wrap;
  background: ${({ theme }) => theme.colors.primaryLight};

  ${({ theme }) => theme.mediab.l1050`
    margin: 0;
  `};
`;

const ContentWrapper = styled.div`
  max-width: ${({ theme }) => `${theme.grid.container.wide}px`};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;

  svg {
    fill: ${({ theme }) => theme.colors.gold};
  }
`;

const contactWrapperLikeCss = css`
  text-decoration: none;
  font-size: ${rem(14)};
  font-weight: 500;
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(21)};
`;

const ContactItem = styled.div`
  padding: ${rem(28)} 0;
  flex: 1 0 33%;
  text-align: center;
  max-width: ${rem(478)};

  &:nth-child(2n + 2) {
    border-left: ${rem(2)} solid ${({ theme }) => theme.colors.white};
    border-right: ${rem(2)} solid ${({ theme }) => theme.colors.white};
  }

  ${({ theme }) => theme.mediab.l925`
    flex: 1 0 50%;

    &:nth-child(2n + 2) {
      border: none;
    }
  `}

  ${({ theme }) => theme.mediab.m580`
    flex: 1 0 100%;
    max-width: initial;
    border-bottom: ${rem(2)} solid ${theme.colors.white} !important;
    text-align: left;
    padding: ${rem(24)} ${rem(16)};
  `}
`;

const ContactLink = styled.a`
  ${contactWrapperLikeCss};

  margin: ${rem(8)} 0;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;

const SmallText = styled.span`
  ${contactWrapperLikeCss};
  display: inline-block;
  font-weight: 300;
`;

export { FooterContactRow };
